module.exports = __webpack_public_path__ + "img/logo.b3117203.svg";